const { Serializer } = require("jsonapi-serializer");

module.exports = {
  createMessageSerializer: (meta = {}) =>
    new Serializer("createMessageSerializer", {
      meta,
      pluralizeType: false,
      keyForAttribute: "snake_case",
      attributes: [
        "message_text",
        "stages",
        "user_email",
        "user_ip"
      ]
    })
};
